import { create } from 'zustand';
import { AuthStatus } from '../hooks/login';
export const useCasablancaStore = create((set) => ({
    authStatus: AuthStatus.None,
    setAuthStatus: (authStatus) => set({ authStatus }),
    authError: null,
    setAuthError: (error) => {
        set({ authError: error ?? null });
    },
}));
//# sourceMappingURL=use-casablanca-store.js.map